export default __webpack_public_path__ + "static/media/aboutthecreator_titleResized.60288216.png";